export class InvoiceParameters {
  public isDispatchedInvoice: boolean = false;
  public isSearchDetail: boolean = false;
  public isRejectedInvoice: boolean = false;
  public isPendingForWorkflowCompletionVoucher: boolean = false;
  public isPendingForWorkflowCompletionPromotion: boolean = false;
  public isPendingForVoucherValidation: boolean = false;
  public isControl: boolean = false;
  public isWaiting: boolean = false;
  public isManual: boolean = false;
  public isComplaintInvoice: boolean = false;
  public isInjection: boolean = false;
  public isPrimaryReferenceRequired: boolean = false;
  public isVatNumberComplianceEnabled: boolean = false;
  public isInvoiceForClient: boolean = false;
  public isInvoiceForGroup: boolean = false;
  public isBDCMandatory: boolean = false;
  public isDuplicateInvoice: boolean = false;
  public isPrescriptorGroup: boolean = false;

  public canCancelProcess: boolean = false;
  public canCreateInPPR: boolean = false;
  public canManageInvoiceAGI: boolean = false;

  public invoiceViewType: string;
}
